import { render } from "./MainNavigation.vue?vue&type=template&id=6e353273&scoped=true"
import script from "./MainNavigation.vue?vue&type=script&lang=js"
export * from "./MainNavigation.vue?vue&type=script&lang=js"

import "./MainNavigation.vue?vue&type=style&index=0&id=6e353273&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e353273"]])

export default __exports__